/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'patent/frigate_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M27.75 12.336V4.25h-8.086L16 .586 12.336 4.25H4.25v8.086L.586 16l3.664 3.664v8.086h8.086L16 31.414l3.664-3.664h8.086v-8.086L31.414 16l-3.664-3.664zm-.5-7.586v7.086L20.164 4.75h7.086zm-22.5 0h7.086L4.75 11.836V4.75zm0 22.5v-7.086l7.086 7.086H4.75zm22.5 0h-7.086l7.086-7.086v7.086zM16 28.586L3.414 16 16 3.414 28.586 16 16 28.586z"/><path pid="1" d="M12 14.333h-1.333V15H12v1.333h-2V17h2v1.333h-1.333V19H12v2h.667V10.333H12zM14.667 22.333h2.666V23h-2.666zM22 17v-.667h-2V15h1.333v-.667H20v-4h-.667V21H20v-2h1.333v-.667H20V17zM15.667 21.667V9h-.334l-.666.667c-.667.666-.667 2-.667 2l-.667.666V21l1.334.667h1zM17.333 9.667L16.667 9h-.334v12.667h1L18.667 21v-8.667L18 11.667s0-1.334-.667-2z"/>'
  }
})
